<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <vat-list/>
    </div>
  </div>
</template>

<script>
import VatList from '../../../components/reports/vat/central/List';
import Sidebar from '../../../components/reports/vat/Sidebar';
import moment from 'moment';



export default {
  components: {
    VatList,
    Sidebar,
  },
  data() {
    return {

    }
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    isDisabled() {
      return !this.storageType || !this.stockDate;
    },
    listLoading() {
      return this.$store.getters['stockValue/loading'];
    },
  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
